import type { CSSProperties } from 'react';
import { neonVar } from '@/utils/neon-utils';

export const sectionSpacingStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  width: '100%',
};

export const baseTextStyle = (
  fontSize: string,
  lineHeight: string,
  fontWeight?: string | number,
  fontStyle: string = 'normal'
): CSSProperties => ({
  fontStyle: fontStyle,
  fontFamily: neonVar('font-family', 'Roboto, Arial, Helvetica, sans-serif'),
  fontSize,
  lineHeight,
  ...(fontWeight ? { fontWeight } : {}),
});

export const headerRowStyle = (
  fontSize: string,
  lineHeight: string,
  fontWeight?: string | number
): CSSProperties => ({
  ...baseTextStyle(fontSize, lineHeight, fontWeight),
  ...tableColumnsStyle,
  justifyContent: 'space-between',
  width: '100%',
  flexWrap: 'wrap',
  gap: '12px',
});

export const infoRowStyle: CSSProperties = {
  display: 'flex',
  // alignItems: 'center',
  width: '100%',
  maxWidth: 700,
  height: 'auto',
  opacity: 1,
  gap: '16px',
  flexWrap: 'nowrap',
};

export const paragraphStyle = (
  fontSize: string,
  lineHeight: string,
  resetMargin: boolean = true
): CSSProperties => ({
  ...baseTextStyle(fontSize, lineHeight),
  ...(resetMargin ? { margin: 0 } : {}),
  maxWidth: 700,
  flex: 1,
  fontWeight: 400,
  color: neonVar('color-text-primary', '#333333'),
});

export const contentStackStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
};

/** Layout for error / empty cards (e.g. NeonErrorPageContent container) */
export const errorCardStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '8px',
};
type MarginKeys = 'margin' | 'marginTop' | 'marginRight' | 'marginBottom' | 'marginLeft';

type MarginStyles = Pick<CSSProperties, Extract<keyof CSSProperties, MarginKeys>>;

export function createMarginStyle(styles: MarginStyles): CSSProperties {
  return styles;
}

export const titleStyle: CSSProperties = {
  ...createMarginStyle({ margin: '0' }),
  fontFamily: neonVar('font-family', 'Roboto, Arial, Helvetica, sans-serif'),
  fontWeight: 500,
  fontStyle: 'normal',
  fontSize: '24px',
  lineHeight: '36px',
  letterSpacing: '0',
  verticalAlign: 'middle',
  color: neonVar('color-text-primary', '#333333'),
};

export const tableColumnsStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
};

export const actionButtonsContainerStyle: CSSProperties = {
  ...tableColumnsStyle,
  gap: '8px',
  width: '100%',
  height: '100%',
  ...createMarginStyle({ marginLeft: '16px' }),
};
export const gridContainerStyle: CSSProperties & Record<string, string> = {
  height: '500px',
  width: '100%',
  overflowX: 'hidden',
  borderRadius: '8px',
  '--ag-header-border-color': 'transparent',
  '--ag-header-row-border': 'none',
  '--ag-header-column-separator-color': 'transparent',
  '--ag-header-column-separator-width': '0px',
};
